<div class="grid-container margin-top wrapper">
    <div class="grid-x grid-margin-x">
        <div class="cell large-12 medium-12 small-12">
            <document-search-options (runSearch)="newSearch($event)" (throwError)="handleError($event)"></document-search-options>
        </div>
        <div class="cell large-12 medium-12 small-12">
            <document-search-results [query]="queryModel" [result]="queryResult" (pageChanged)="onPageChanged($event)" (sortChanged)="onSorting($event)" (throwError)="handleError($event)"></document-search-results>
        </div>
    </div>    
</div>